import api from './api';

// 📌 **Retrieve all blogs**
export const getBlogs = async () => {
  try {
    const response = await api.get('/blogs');
    
    return response.data.map(blog => ({
      ...blog,
      publishDate: blog.publishDate ? new Date(blog.publishDate).toISOString() : null, // Ensure correct date format
    }));
  } catch (error) {
    console.error('❌ Error in getBlogs:', error);
    throw error;
  }
};

// 📌 **Retrieve a single blog by ID**
export const getBlogById = async (id) => {
  try {
    const response = await api.get(`/blogs/${id}`);
    const blog = response.data;

    return {
      ...blog,
      publishDate: blog.publishDate ? new Date(blog.publishDate).toISOString() : null, // Ensure date format consistency
    };
  } catch (error) {
    console.error(`❌ Error in getBlogById (ID: ${id}):`, error);
    throw error;
  }
};

// 📌 **Retrieve a blog by its slug**
export const getBlogBySlug = async (slug) => {
  try {
    const response = await api.get(`/blogs/slug/${slug}`);
    const blog = response.data;

    return {
      ...blog,
      publishDate: blog.publishDate ? new Date(blog.publishDate).toISOString() : null, // Standardize date format
    };
  } catch (error) {
    console.error(`❌ Error in getBlogBySlug (Slug: ${slug}):`, error);
    throw error;
  }
};

// 📌 **Create a new blog**
export const createBlog = async (blogData) => {
  try {
    const formattedData = {
      ...blogData,
      publishDate: new Date(blogData.publishDate).toISOString(), // Ensure full date format before sending
    };

    const response = await api.post('/blogs', formattedData);
    return response.data;
  } catch (error) {
    console.error('❌ Error in createBlog:', error);
    throw error;
  }
};

// 📌 **Update an existing blog**
export const updateBlog = async (id, blogData) => {
  try {
    const formattedData = {
      ...blogData,
      publishDate: new Date(blogData.publishDate).toISOString(), // Ensure full date format before updating
    };

    await api.put(`/blogs/${id}`, formattedData);
  } catch (error) {
    console.error(`❌ Error in updateBlog (ID: ${id}):`, error);
    throw error;
  }
};

// 📌 **Delete a blog by ID**
export const deleteBlog = async (id) => {
  try {
    await api.delete(`/blogs/${id}`);
  } catch (error) {
    console.error(`❌ Error in deleteBlog (ID: ${id}):`, error);
    throw error;
  }
};
